import { SxProps, Theme } from '@mui/material/styles';

export const facetNavigationAccordionDetailsSX: SxProps<Theme> = {
	px: '10px',
	py: 0,
	m: 0,
	minHeight: 'initial',
};
